const markSrc = (dark) => (dark ? "/logo-white.png" : "/logo-dark.png");

export const LogoMark = ({ className = "h-9 w-auto", dark = false }) => (
  <img
    src={markSrc(dark)}
    alt="Universal Engineers logo"
    className={`${className} shrink-0`}
    data-testid="logo-mark"
  />
);

const Logo = ({ dark = false, compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-auto sm:h-10" dark={dark} />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display font-extrabold tracking-tight ${
          dark ? "text-white" : "text-navy"
        } ${compact ? "text-base" : "text-lg"}`}
      >
        UNIVERSAL <span className="text-safety">ENGINEERS</span>
      </span>
      <span
        className={`font-mono text-[9px] uppercase tracking-[0.22em] mt-1 ${
          dark ? "text-slate-400" : "text-slate-500"
        }`}
      >
        3M Authorised Channel Partner
      </span>
    </span>
  </span>
);

export default Logo;
